import { Route, Routes, useParams } from 'react-router-dom'
import { useAppState } from '@/app/hooks/useAppState'
import { useEffect } from 'react'
import ProductionRouteViewPage from './pages/production-route-view'

export default function ProductionRoute() {
  const { installationId } = useParams<{ installationId: string }>()
  const { setSelectedInstallationId } = useAppState()

  useEffect(() => {
    if (installationId) {
      setSelectedInstallationId(installationId)
    }
  }, [installationId, setSelectedInstallationId])

  return (
    <Routes>
      <Route path="/:productionRouteId/view" element={<ProductionRouteViewPage />} />
    </Routes>
  )
}
